import { useState } from "react";
import { Pole } from "../../../types/planBT.types";
import PoleSelectorPresenter from "../../Pole/PoleSelector/PoleSelector";
import { NodePlanPatch } from "../../../types/node.types";
import NodeSelectorView from "./NodeSelectorView/NodeSelectorView";


export interface NodeSelectorPresenterProps {
    valueNode?: NodePlanPatch | null;
    setValue: (node: NodePlanPatch) => void;
    type : "POLE" | "TRANSFORMER" | "METER" | "CENTRALPLANT";
    isError?: boolean;
    variant?: "dark" | "light";
    label?: string;
}
export default function NodeSelectorPresenter({valueNode, setValue, type, isError, variant, label}:NodeSelectorPresenterProps) {



    const [pole, setPole] = useState<Pole | null>(null)

    const handlechange = (pole: Pole) => {
        setPole(pole);
        setValue({
            node_type: type,
            node_hosted_id: pole.pole_id,
            node_id: pole.pole_node
        });
    }

    const initPoleId = valueNode?.node_hosted_id || null;

  return (
    <NodeSelectorView isError={isError} label={label} PoleSelectorPresenter={() =>(<PoleSelectorPresenter label={" "} value={pole} onChange={handlechange} variant="dark" initPoleId={initPoleId} isError={isError}/>) } variant={variant}/>
  )
}
